import * as Sentry from "@sentry/react";

const sentryEnabled = process.env.REACT_APP_SENTRY_ENABLED;

if (sentryEnabled) {
  // initialize sentry logs
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENVIRONMENT,
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(), // ⭐ required for tracing
      Sentry.replayIntegration()
    ]
  });
}
